import { call, put, select, takeLatest } from "redux-saga/effects";
import { FETCH_BATTLE_CARD_MP_REQUEST, fetchBattleCardMpFailure, fetchBattleCardMpSuccess } from "../../actions/meetingPrep/battleCardActions";
import axios from "axios";
import qs from 'qs';
import iq_api_v2 from "../../../../services/iqApiV2";

async function findBattleCardMpData(opportunityId="") {
    const data = qs.stringify({
      meeting_prep_id: opportunityId,
    });
  
    // console.log("data",data)
    try {
      const response = await iq_api_v2.post("/meeting_prep/get_details?"+data, '')

      return response?.data
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
    }

  }

// Worker Saga
function* fetchBattleCardMpSaga() {
  try {
    const payload = yield select(
      (state) => state?.battleCardMpReducer?.payload
    );
    const { opportunityId=""} = payload;
    const data = yield call(
        findBattleCardMpData,
        opportunityId
    );
    yield put(fetchBattleCardMpSuccess(data?.data || {}));
  } catch (error) {
    yield put(fetchBattleCardMpFailure(error.message));
  }
}

// Watcher Saga
export function* watchBattleCardMpData() {
  yield takeLatest(FETCH_BATTLE_CARD_MP_REQUEST, fetchBattleCardMpSaga);
}
